import PinDashboard from "./PinDashboard";

const PinMessage = ({ msgId, setDashboards }) => {
  return (
    <div>
      <PinDashboard setDashboards={setDashboards} msgId={msgId} />
    </div>
  );
};

export default PinMessage;
